import { render, staticRenderFns } from "./CustomerDescription.vue?vue&type=template&id=64695b02&scoped=true"
import script from "./CustomerDescription.vue?vue&type=script&lang=js"
export * from "./CustomerDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64695b02",
  null
  
)

export default component.exports